module.exports = __webpack_public_path__ + "fonts/1b26dd489d599ac5fe83551f5314abeb.svg";